<template>
  <div class="flexLeftRow" style="align-items: center">
    <div class="imgBox" v-if="this.imgSrc || this.icon">
      <img v-if="isImage" :src="this.imgSrc" class="w-6 h-6" height="20" />
      <component v-else :is="this.icon" class="w-6 h-6" />
      <!-- {{ this.icon }} -->
    </div>
    <h3>{{ this.title }}</h3>
    <strong v-if="this.hook" style="margin-left: 10px">{{ this.hook }}</strong>
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";

export default {
  name: "NodeHeader",
  components: {},
  methods: {
    // getImage() {
    //   console.log("GOT TO HERE");
    //   console.log(this.flowImgs);
    //   return (
    //     this.flowImgs[`/src/assets/flow_logos/${this.hook}.svg`]?.default || ""
    //   );
    // },
  },
  props: {
    title: String,
    icon: Object,
    hook: String,
  },
  setup() {
    return {};
  },
  data() {
    const requireContext = require.context(
      "@/assets/flow_logos",
      false,
      /\.svg$/
    );
    const flowImgs = requireContext.keys().reduce((images, path) => {
      images[path] = requireContext(path);
      return images;
    }, {});

    console.log(this.icon != null);
    // console.log(flowImgs);
    // console.log(flowImgs[`./${this.hook}.svg`]);
    // console.log(flowImgs[`./${this.hook}.svg`]?.default || "");
    console.log(this.hook);
    console.log(this.icon);
    console.log(this.title);
    return {
      isImage: this.icon == null,
      imgSrc: this.icon == null ? flowImgs[`./${this.hook}.svg`] : "",
    };
  },
};
</script>

<style scoped>
.imgBox {
  height: 35px;
  width: 35px;
  background: #721cff10;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
</style>
